import { BaseSelectField } from "../../components/BaseSelectField/BaseSelectField";
import EditableFiscalYearList  from "../../hooks/EditableFiscalYear";
import IsNullOrEmpty from "../../components/IsNullOrEmpty";
import { useState, useEffect } from 'react';
import GetFetch from '../../hooks/GetFetch';
import { Fragment } from "react";

const FiscalYearDropdown = (
    { 
        enableSearch,
        inputAttribute,
        label,
        onEnterKeyDown,
        optionUpdatedByUser,
        value,
        isVisible
    }
) => {
    const [loading, setLoading] = useState(false);
    const [fiscalYearsList, setFiscalYearsList] = useState(null);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const generateFiscalYears = () => {
        return EditableFiscalYearList();
    };
 
    const fiscalYears = generateFiscalYears();

    useEffect(() => {
        fetchFiscalYears();
    }, []);

    const fetchFiscalYears = async () => {
        setLoading(true);
        const fyList = await GetFetch('/v1/BillPeriod');
        if (fyList.Success === true) {
            console.log(fyList)
            setFiscalYearsList(fyList.Message.map(m => m.FiscalYear));
            setError(false);
            setErrorMessage(null);
        }
        else {
            setError(true);
            setErrorMessage(fyList.Errors[0].Message);
            setFiscalYearsList(null);
            console.log("What went wrong:", fyList.Errors);
        }
        setLoading(false);
    };

      
    return (
        <Fragment>
            <BaseSelectField 
                data={fiscalYears}
                enableSearch={enableSearch}
                inputAttribute={inputAttribute}
                label={label}
                onEnterKeyDown={onEnterKeyDown}
                onOptionChanged={(e) => e.component.validate()}
                optionUpdatedByUser={optionUpdatedByUser}
                validationRuleCallback={() => !IsNullOrEmpty(value)}
                value={value}
                isVisible={isVisible}
            />
        </Fragment>
    );
};

 export default FiscalYearDropdown;